var map = {
  "./bmo/en-US.json": "92456",
  "./bmo/fr-CA.json": "32069",
  "./boc/en-US.json": "4930",
  "./boc/fr-CA.json": "18275",
  "./corpay/en-US.json": "21058",
  "./corpay/fr-CA.json": "5347",
  "./extend/en-US.json": "49516",
  "./extend/fr-CA.json": "61081",
  "./jpm/en-US.json": "7079",
  "./jpm/fr-CA.json": "57042",
  "./pacwest/en-US.json": "76429",
  "./pacwest/fr-CA.json": "20932",
  "./pnc/en-US.json": "37441",
  "./pnc/fr-CA.json": "96152"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62149;
